import NotificationsModel from './notifications-model';
import NotificationsView from './notifications-view';
import * as UIService from '../../services/ui-service';
import AuthService from '../../services/auth-service';

export default class NotificationsPresenter {
  constructor(model, view, appInterface) {
    this.model = model || new NotificationsModel();
    this.view = view || new NotificationsView();
    this.appInterface = appInterface || {};
  }

  async init() {
    this.model.loadUserState();

    // Setup button listeners regardless of auth to show warning toast when needed
    this.setupEventListeners();

    if (!this.model.isAuthenticated) {
      this.showAuthRequired();
      this.updateNotificationButtonState();
      return;
    }

    this.loadNotifications();
    this.updateNotificationButtonState();
  }

  showAuthRequired() {
    this.view.showAuthRequired('#notifications-container', () => this.appInterface.navigateTo('auth'));
  }

  loadNotifications() {
    const notifications = this.model.getNotifications();
    this.view.renderNotifications(notifications, '#notifications-container');
    
    this.appInterface.reinitTooltips();
  }

  setupEventListeners() {
    this.view.setupNotificationButtonEventListener(() => this.toggleNotifications());
    this.view.setupNotificationInteractionEventListeners((notificationId) => this.deleteNotification(notificationId));
  }

  toggleNotifications() {
    if (!this.model.isAuthenticated) {
      if (this.appInterface.showToast) {
        this.appInterface.showToast('Masuk terlebih dahulu untuk mengaktifkan notifikasi', 'warning');
      }
      return;
    }

    if (this.model.isPushSubscribed()) {
      this.appInterface.unsubscribeFromNotifications();
    } else {
      this.appInterface.enableNotifications();
    }
  }

  deleteNotification(notificationId) {
    const success = this.model.removeNotification(notificationId);
    
    if (success) {
      this.view.removeNotificationFromDOM(notificationId);
      if (this.appInterface.removeNotificationFromApp) {
        this.appInterface.removeNotificationFromApp(notificationId);
      }
      
      this.appInterface.showToast('Notifikasi dihapus', 'success');
      
      const remainingNotifications = this.model.getNotifications();
      if (remainingNotifications.length === 0) {
        this.view.showEmptyState('#notifications-container', 'Belum ada notifikasi');
      }
    }
  }

  updateNotificationButtonState() {
    const isSubscribed = this.model.isPushSubscribed();
    this.view.updateNotificationButton(isSubscribed);
  }

  addNotification(title, message) {
    if (!this.model.isAuthenticated) return;
    
    const notification = this.model.addNotification(title, message);
    this.appInterface.updateNotificationBubble();
    
    // Refresh tampilan jika sedang di halaman notifications
    if (this.appInterface.getCurrentPage && this.appInterface.getCurrentPage() === 'notifications') {
      this.loadNotifications();
    }
    
    return notification;
  }

  updateNotificationButton(isSubscribed) {
    this.model.setPushSubscription(isSubscribed ? {} : null);
    this.view.updateNotificationButton(isSubscribed);
  }

  cleanup() {
    this.view.cleanup();
  }

  refresh() {
    this.loadNotifications();
  }
}